import { useState, useEffect, useRef } from 'react';

export const useRender = () => {
  const [_, setState] = useState({});
  return () => setState({});
};
